import React, { useEffect } from 'react'
import Breadcrumb from '../../Components/Breadcrumb/Breadcrumb'
import AllAcountsSection from '../../Components/AllAccountsSection/AllAcountsSection'
import SavePlusAccountComponent from "../../Components/SavePlusAccount/SavePlusAccountComponent";
// import Arrow_down from "../../assets/images/IZB/arrow_down.png";
import { AiOutlineArrowRight } from "react-icons/ai";

import IndoDairyProductionSchemeAccordion from './IndoDairyProductionSchemeAccordion';
// import AgroFinanceAccordion from './AgroFinanceAccordion';
import {question} from "./IndoDairyProductionSchemeData"

const IndoDairyProductionScheme = () => {
const Arrow_down = "https://izbassetsmain.blob.core.windows.net/izbwebassets/arrow_down.png";
const img1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Dairy-Production-Scheme-banner.png";
const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/agro-finance-banner.png";

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const accountContent = "Aimed at facilitating the maintaining the increase in milk production among smallholder dairy farmers through the provision of short-term financing to cover animal feeding and veterinary costs."
  return (
    <>
     <Breadcrumb Heading="Indo Dairy Production Scheme" img={BackgroundBrundcrumb}  show={true} btnTxt="Apply Now"/>
      <SavePlusAccountComponent
        heading="Indo Dairy Production Scheme"
        subHeading="Know About"
        content={accountContent}
        btnTxt="Apply Now"
        img={img1}
        logo={true}
      />

      <section
        className="page-contains-area"
        style={{ backgroundColor: "#FFF5E7" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="page-contains-box">
                <div className="page-contains-btn">
                  <ul className="navigation clearfix scroll-nav">
                    <li className="current">
                      <a href="#benefits">
                        Features & Details
                      </a>
                    </li>
                  
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="MSMEAccodion">
        <div className="container justify-content-center mt-5">
          <div className="faq-style1__content">
            <ul className="accordion-box mb-5">
              {question.map((item) => {
                const { id } = item;
                return <IndoDairyProductionSchemeAccordion key={id} {...item} />;
              })}
            </ul>
          </div>
        </div>
      </section>
      <div className="container">
        <div
          className="bg-light my-3"
          style={{
            padding: "20px 0px 20px 10px",
          }}
        >
          <h6 style={{ color: "#9E1B1E", textAlign:"left" }}>Call <a href="tel:8002" style={{color: "#9E1B1E"}}>8002</a> or email <a href="mailto:credit@izb.co.zm" style={{color: "#9E1B1E"}}>credit@izb.co.zm</a></h6>
        </div>
      </div>
      <AllAcountsSection/>
    </>
  )
}

export default IndoDairyProductionScheme;